export default __webpack_public_path__ + "static/media/hammer.8ec41b78.png";